import { render, staticRenderFns } from "./ToolbarTextareaFontSize.vue?vue&type=template&id=b725af1e"
import script from "./ToolbarTextareaFontSize.vue?vue&type=script&lang=js"
export * from "./ToolbarTextareaFontSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports